import { defineComponent, type PropType } from "vue";
import type { LeadFormProps } from "@newgenerated/shared/schema";

import { getUtmData } from "@/components/leadform/_utm-extractor";
import { LeadFormComponent } from "@/components/leadform/LeadFormComponent";

export const LeadFormWidget = defineComponent({
  props: {
    leadFormProps: {
      type: Object as PropType<LeadFormProps>,
      required: true,
    },
  },
  setup: (props) => {
    const utm = getUtmData();
    return () => (
      <LeadFormComponent
        countries={props.leadFormProps.countries}
        preselectedCountry={props.leadFormProps.country}
        // leadSource={props.leadFormProps.leadSource}
        fullWidth={props.leadFormProps.fullWidth}
        utmCampaign={utm.campaign}
        utmContent={utm.content}
        utmId={utm.id}
        utmMedium={utm.medium}
        utmSource={utm.source}
        utmTerm={utm.term}
      />
    );
  },
});
